/**
 * Product page, desktop, one image per row: a sticky column of thumbnails on the left of the images.
 * The thumbnail of the image in view is highlighted while scrolling; clicking one scrolls to its image.
 */
(() => {
  const gallery = document.querySelector('.product-information media-gallery.media-gallery--one-column.media-gallery--grid');
  if (!gallery) return;

  let rail = null;
  let observer = null;

  const headerHeight = () => document.querySelector('#header-component')?.offsetHeight ?? 0;

  const smallestSrc = (img) => {
    const first = (img.getAttribute('srcset') || '').split(',')[0]?.trim().split(' ')[0];
    return first || img.currentSrc || img.src;
  };

  const build = () => {
    const items = [...gallery.querySelectorAll(':scope > .media-gallery__grid > .product-media-container')];
    observer?.disconnect();
    rail?.remove();
    if (items.length < 2) return;

    rail = document.createElement('nav');
    rail.className = 'pdp-thumbs';
    rail.setAttribute('aria-label', 'Product images');
    const list = document.createElement('ul');
    list.className = 'pdp-thumbs__list';
    rail.append(list);

    const buttons = items.map((item, index) => {
      const img = item.querySelector('img');
      const li = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pdp-thumbs__button';
      button.setAttribute('aria-label', `Image ${index + 1}`);
      if (img) {
        const thumb = document.createElement('img');
        thumb.src = smallestSrc(img);
        thumb.alt = '';
        thumb.loading = 'lazy';
        thumb.width = 64;
        thumb.height = 64;
        button.append(thumb);
      } else {
        button.textContent = String(index + 1);
      }
      button.addEventListener('click', () => {
        const top = item.getBoundingClientRect().top + window.scrollY - headerHeight() - 24;
        window.scrollTo({ top, behavior: 'smooth' });
      });
      li.append(button);
      list.append(li);
      return button;
    });

    gallery.prepend(rail);

    const setActive = (index) => {
      buttons.forEach((button, i) => button.toggleAttribute('aria-current', i === index));
      const active = buttons[index];
      if (!active) return;
      // Keep the active thumbnail in view when the list itself scrolls
      const railBox = list.getBoundingClientRect();
      const box = active.getBoundingClientRect();
      if (box.top < railBox.top || box.bottom > railBox.bottom) {
        list.scrollTo({ top: list.scrollTop + box.top - railBox.top - railBox.height / 2 + box.height / 2, behavior: 'smooth' });
      }
    };

    // The image crossing the line at 40% of the screen height is the one in focus
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) setActive(items.indexOf(entry.target));
        }
      },
      { rootMargin: '-40% 0px -60% 0px' }
    );
    items.forEach((item) => observer.observe(item));
    setActive(0);
  };

  build();

  // Variant changes can re-render the images
  let pending = 0;
  new MutationObserver(() => {
    if (pending) return;
    pending = requestAnimationFrame(() => {
      pending = 0;
      const items = gallery.querySelectorAll(':scope > .media-gallery__grid > .product-media-container');
      if (!rail || items.length !== rail.querySelectorAll('button').length || !rail.isConnected) build();
    });
  }).observe(gallery, { childList: true });
})();
